import { PANELMANAGER_SET_PANELPROPS } from '../../constants';


export type SetPanelPropsAction = {
    type: typeof PANELMANAGER_SET_PANELPROPS;
    panelKey: string;
    panelProps: { [ key: string ]: any };
}

/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 * @param {Object} panelProps
 *
 * @return {SetPanelPropsAction}
 */
export default function setPanelProps( panelKey: string, panelProps: { [ key: string ]: any } ): SetPanelPropsAction {
    return {
        type: PANELMANAGER_SET_PANELPROPS,
        panelKey,
        panelProps
    };
}
